/*
  VEYNOU: Lagerhinweis im Groessen-Popover, passend zur gewaehlten Auswahl.

  Warum es das braucht: Das Skript in sections/main-product.liquid setzt den
  Hinweis "Sofort lieferbar" bei Produkten mit zwei Optionen (Metall, Groesse)
  ohne Ruecksicht auf die gewaehlte Farbe - es genuegt, dass irgendeine Variante
  mit Bestand diese Groesse traegt. Beim Gelbgold-Ring standen deshalb die
  Weissgold-Groessen. Ausserdem lief es nur beim Klick auf das Feld, weshalb der
  erste Blick falsch war und sich erst beim zweiten Oeffnen korrigierte.

  Dieses Skript rechnet nach der aktuellen Auswahl und laeuft beim Laden der
  Seite, nach jedem Variantenwechsel und nach jedem Klick. Es setzt die
  Beschriftung der Popover-Eintraege danach neu, also nach dem alten Skript.

  Wie streng gerechnet wird: Ein Eintrag gilt als lieferbar, wenn es eine
  Variante mit Bestand gibt, die an dieser Optionsstelle den Wert des Eintrags
  traegt und in allen DAVOR liegenden Optionen der aktuellen Auswahl entspricht.
  Optionen dahinter bleiben offen. Beispiel Karat vor Ringgroesse: Steht die
  Auswahl auf Gelbgold und 2ct., liegt in 2ct. nichts am Lager, wohl aber 1ct.
  in Groesse 60. Wuerde die Groesse mitgerechnet, bliebe die ganze Seite ohne
  Hinweis, obwohl etwas da ist. So wird 1ct. als lieferbar gezeigt, und nach dem
  Wechsel auf 1ct. erscheint die Groesse 60.
*/
(function () {
  if (window.vyStockLabelsReady) return;
  window.vyStockLabelsReady = true;

  var LABEL = window.VY_IN_STOCK_LABEL || 'Sofort lieferbar';

  function allVariants() {
    var el = document.getElementById('variantData');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      return data && data.length ? data : null;
    } catch (e) {
      return null;
    }
  }

  // Bestand kommt aus dem versteckten Select, dort haengt je Variante das
  // Attribut quantity mit inventory_quantity. Nie available benutzen: der Shop
  // verkauft weiter, wenn nichts da ist, deshalb ist available immer true.
  function stockMap() {
    var map = {};
    document.querySelectorAll('#product-select option').forEach(function (opt) {
      map[String(opt.value)] = parseInt(opt.getAttribute('quantity') || '0', 10) || 0;
    });
    return map;
  }

  // Die aktuelle Auswahl steht am zuverlaessigsten im Warenkorb-Formular, weil
  // sie dort bei jedem Variantenwechsel mitgefuehrt wird. Der versteckte Select
  // ist nur der Rueckfall.
  function currentVariant(variants) {
    var id = '';
    var field = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (field && field.value) {
      id = field.value;
    } else {
      var select = document.querySelector('#product-select');
      if (select && select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
        id = select.options[select.selectedIndex].value;
      }
    }
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function baseLabel(btn) {
    if (!btn.dataset.vyBase) {
      var text = btn.dataset.valueUpdate || btn.textContent || '';
      btn.dataset.vyBase = text.trim();
    }
    return btn.dataset.vyBase;
  }

  function refresh() {
    var variants = allVariants();
    if (!variants) return;
    var current = currentVariant(variants);
    if (!current) return;
    var stock = stockMap();

    document.querySelectorAll('.Popover__Value:not(.diamant-qualitat)').forEach(function (btn) {
      var position = parseInt(btn.dataset.optionPosition || '0', 10);
      var label = baseLabel(btn);
      if (!position) return;
      var value = btn.dataset.value;

      var inStock = variants.some(function (variant) {
        var options = variant.options || [];
        if (String(options[position - 1]) !== String(value)) return false;
        // Nur die Optionen VOR dieser Stelle muessen zur aktuellen Auswahl
        // passen, spaetere bleiben offen.
        for (var i = 0; i < position - 1; i++) {
          if (String(options[i]) !== String((current.options || [])[i])) return false;
        }
        return (stock[String(variant.id)] || 0) > 0;
      });

      var markup = inStock ? label + ' <span class="spaid">' + LABEL + '</span>' : label;
      if (btn.innerHTML.trim() !== markup) btn.innerHTML = markup;
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    // Kurz warten, damit das alte Skript zuerst fertig ist und nicht ueberschreibt.
    timer = setTimeout(refresh, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  document.addEventListener('click', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('variant:change', schedule);
})();
